import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { StringHelper as StringHelperFunc } from "../../../../../../../../react-core/Helpers/StringHelper";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { PerformanceMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { ViewType } from "../../../../../../../../Wrap/Mapping/PortfolioAnalysis/Investment/Enum/ViewType";
import { PerformanceDetailsModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PerformanceDetailsModel";
import { TableHeader } from "../../../../../../../Shared/Table/Components/TableHeader";
import { TableRow } from "../../../../../../../Shared/Table/Components/TableRow";
import { ScrollTable } from "../../../../../../../Shared/Table/ScrollTable";
import { ITableConfig } from "../../../../../../../Shared/Table/Table";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { PerformanceDataView, returnTooltip } from "../Resource/Contents";
import { UnmountClosed } from "react-collapse";
import { PerformanceDetailsColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceDetailsColumns";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { Contents } from "../../Insights/Resource/Contents";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { IProductPerformanceDetailModel, IPerformanceDetailsModel } from "../Store/Variable";
import { Spinner } from "../../../../../../../../react-core/Html/Spinner";

export enum PerformanceDetailRowType {
    productRow = "product-heading",
    subTotal = "sub-total",
    assertRow = "sub-heading",
    groupRow = "sub-heading-main",
    total = "total",
    investment = "",
}

interface IDetailTableProps {
    data: IProductPerformanceDetailModel[];
    return: PerformanceMethod;
    view: ViewType;
    assetType: AssetClassType;
    getModel: (instrumentIds, isToogle, productIndex, modelId) => void;
    switchTab: (view: PerformanceDataView) => void;
    colSetting: any[];
    isLoading: boolean;
}

export const getDetailsCol = (
    props: IDetailTableProps,
    type?: PerformanceDetailRowType,
    productIndex?,
    isUnderlying?: boolean
): ITableConfig[] => {
    const { colSetting } = props;

    return [
        {
            title: "Investment",
            key: "InstrumentName",
            tableFilter: PerformanceDetailsColumns.Investment,
            render: (data, row, index) => {
                if (type == PerformanceDetailRowType.subTotal) {return "Sub total";}
                if (type == PerformanceDetailRowType.total) {return "Total";}
                if (type == PerformanceDetailRowType.groupRow)
                    {return index === 0 ? (
                        <span className="header holdings">Investment holdings</span>
                    ) : index === 1 ? (
                        <span className="header portfolios">Managed portfolios</span>
                    ) : (
                        <span className="header opi">Off Platform Investments</span>
                    );}
                return row.FactSheetUrl ? (
                    <a className={"hyperlink"} target="_blank" href={row.FactSheetUrl}>
                        {data}
                    </a>
                ) : (
                    data
                );
            },
            toogleOptions: (row) => {
                if (!row.isModel) {return { toogleable: false };}
                return {
                    toogleable: true,
                    isToogle: row.isToogle,
                    onToogle: (isToogle) =>
                        props.getModel(
                            row.HubAccountIds && row.HubAccountIds?.length != 0
                                ? row.HubAccountIds
                                : [row.InstrumentCode],
                            isToogle,
                            productIndex,
                            row.InstrumentCode
                        ),
                };
            },
            filterOption: { disableEdit: false },
        },
        {
            title: "Opening value",
            key: "OpeningValue",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            tableFilter: PerformanceDetailsColumns.OpeningValue,
            render: (data, row, index) => {
                return MoneyDisplayHelper.getMoneyFormat(data);
            },
            filterOption: { disableEdit: true },
        },
        {
            title: "Buys",
            key: "Buys",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            tableFilter: PerformanceDetailsColumns.Buys,
            render: (data, row, index) => {
                if (row.InstrumentCode == "GBPCash") {return <span>N/A</span>;}
                return MoneyDisplayHelper.getMoneyFormat(data);
            },
            filterOption: { disableEdit: true },
        },
        {
            title: "Sells",
            key: "Sells",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            tableFilter: PerformanceDetailsColumns.Sells,
            render: (data, row, index) => {
                if (row.InstrumentCode == "GBPCash") {return <span>N/A</span>;}
                return MoneyDisplayHelper.getMoneyFormat(data);
            },
            filterOption: { disableEdit: true },
        },
        {
            title: (
                <Permission
                    userClaim={UserClaim.AdviserPortalRealisedGainLossCanView}
                    replaceChildren="Realised gain/loss"
                >
                    <span className="hyperlink" onClick={() => props.switchTab(PerformanceDataView.RealisedGainLoss)}>
                        Realised gain/loss
                    </span>
                </Permission>
            ),
            tableFilter: PerformanceDetailsColumns.RealisedGainLoss,
            key: "RealisedGain",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                data.Amount = Math.round(data.Amount * 100) / 100;
                return MoneyDisplayHelper.getMoneyFormat(data);
            },
            filterTitle: "Realised gain/loss",
            filterOption: { disableEdit: false },
        },
        {
            title: (
                <Permission
                    userClaim={UserClaim.AdviserPortalUnrealisedGainLossCanView}
                    replaceChildren="Unrealised gain/loss"
                >
                    <span className="hyperlink" onClick={() => props.switchTab(PerformanceDataView.UnrealisedGainLoss)}>
                        Unrealised gain/loss
                    </span>
                </Permission>
            ),
            filterTitle: "Unrealised gain/loss",
            tableFilter: PerformanceDetailsColumns.UnRealisedGainLoss,
            key: "UnRealisedGain",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                data.Amount = Math.round(data.Amount * 100) / 100;
                return MoneyDisplayHelper.getMoneyFormat(data);
            },
            filterOption: { disableEdit: false },
        },
        {
            title: (
                <Permission userClaim={UserClaim.AdviserPortalPerformanceIncomeCanView} replaceChildren={"Income"}>
                    <span className="hyperlink" onClick={() => props.switchTab(PerformanceDataView.Income)}>
                        Income
                    </span>
                </Permission>
            ),
            filterTitle: "Income",
            tableFilter: PerformanceDetailsColumns.Income,
            key: "Income",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                data.Amount = Math.round(data.Amount * 100) / 100;
                return MoneyDisplayHelper.getMoneyFormat(data);
            },
            filterOption: { disableEdit: false },
        },
        {
            title: "Gain/loss",
            key: "GainLoss",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            tableFilter: PerformanceDetailsColumns.Gainloss,
            render: (data, row, index) => {
                const positive = data.Amount >= 0 ? "text-positive" : "text-negative";
                data.Amount = Math.round(data.Amount * 100) / 100;
                return <span className={positive}>{MoneyDisplayHelper.getMoneyFormat(data)}</span>;
            },
            filterOption: { disableEdit: true },
        },
        {
            title: (
                <span>
                    Return %
                    <AriaTooltip cssWrapper="is-info-icon to-the-left ml-6" showCloseButton={true}>
                        <b>{returnTooltip.title[props.return]}</b> - {returnTooltip.content[props.return]}
                    </AriaTooltip>
                </span>
            ),
            filterTitle: "Return %",
            key: "Return",
            tableFilter: PerformanceDetailsColumns.Return,
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                if (
                    type == PerformanceDetailRowType.subTotal ||
                    type == PerformanceDetailRowType.total ||
                    type == PerformanceDetailRowType.groupRow
                )
                    {return " ";}
                if (row.InstrumentCode == "GBPCash") {return <span>N/A</span>;}
                return (
                    <span className={data >= 0 ? "text-positive" : "text-negative"}>
                        {Number(Math.round(data * 10000) / 100).toFixed(2) + "%"}
                    </span>
                );
            },
            filterOption: { disableEdit: true },
        },
        {
            title: "Closing value",
            key: "ClosingValue",
            thCssWrapper: "cell-10 cell-right",
            tdCssWrapper: "cell-right",
            tableFilter: PerformanceDetailsColumns.ClosingValue,
            render: (data, row, index) => {
                return MoneyDisplayHelper.getMoneyFormat(data);
            },
            filterOption: { disableEdit: true },
        },
    ];
};

export const DetailTable = (props: IDetailTableProps) => {
    if (!props.data || !props.colSetting || props.isLoading) {return (
        <div className="text-center">
            <h3>Performance details loading</h3>
            <p>
                This may take a few moments. Please do not move away from this page.
            </p>
            <Spinner notFull={true} />
        </div>
    );}
    if (props.data.length == 0) {return <Alert alertType={AlertType.Warning} message={Contents.noDataErrorMessage} />;}

    const StringHelper = new StringHelperFunc();
    const _col = (type?: PerformanceDetailRowType, productIndex?, isUnderlying?: boolean) =>
        getDetailsCol(props, type, productIndex, isUnderlying).filter((ele) =>
            props.colSetting.some((item) => item.Column == ele.tableFilter && item.Enabled)
        );

    const renderRow = (
        type: PerformanceDetailRowType,
        data: IPerformanceDetailsModel | PerformanceDetailsModel,
        index,
        productIndex?,
        isUnderlying?
    ) => {
        return (
            <>
                <TableRow data={data} col={_col(type, productIndex, isUnderlying)} index={index} rowCssWrapper={(isUnderlying && type.length == 0)? 'sub-investment' : type } />

                {(data as IPerformanceDetailsModel).underlyingModel ? (
                    (data as IPerformanceDetailsModel).underlyingModel.map((group) =>
                        renderInvestmentGroup(group, 0, -1, true)
                    )
                ) : null}
            </>
        );
    };

    const renderHeader = () => {
        return <TableHeader col={_col()} />;
    };

    const renderNoDataRow = (type: PerformanceDetailRowType, row) => {
        if (type == PerformanceDetailRowType.productRow)
            {return (
                <tr className={`${type} ${StringHelper.getDonutClass(row.ProductDisplayName)}`}>
                    <td className="pt-12 pb-12 cell-no-break" colSpan={_col().length}>
                        <span
                            aria-hidden="true"
                            className={"product-legend " + StringHelper.getDonutClass(row.ProductDisplayName)}
                        ></span>
                        <span className={StringHelper.getDonutClass(row.ProductDisplayName) + "-text"}>
                            {row.ProductDisplayName}
                        </span>
                        <br />
                        <span className="account">{row.ClAccountId}</span>
                    </td>
                </tr>
            );}
        return (
            <tr className={type}>
                <td colSpan={_col().length}>
                    <span className="header">{row}</span>
                </td>
            </tr>
        );
    };

    const renderInvestmentGroup = (groupData, index, productIndex?, isUnderlying?: boolean) => {
        const rows = groupData.PerformanceDetailsWithFlag || groupData.PerformanceDetails;
        return (
            <>
                {index === 0 && props.assetType !== AssetClassType.NotSet
                    ? renderNoDataRow(PerformanceDetailRowType.assertRow, groupData.AssetSubType)
                    : null}
                {rows.map((investment, index) => {
                    return renderRow(
                        PerformanceDetailRowType.investment,
                        investment,
                        index,
                        productIndex,
                        isUnderlying
                    );
                })}
                {index === 0 && props.assetType !== AssetClassType.NotSet
                    ? renderRow(PerformanceDetailRowType.subTotal, groupData, 0)
                    : null}
            </>
        );
    };

    const renderSection = (subTotal, index, data, productIndex) => {
        if (!data || data.length == 0) {return null;}
        return (
            <>
                {props.assetType !== AssetClassType.NotSet &&
                    renderRow(PerformanceDetailRowType.groupRow, subTotal, index)}
                {data.map((group) => renderInvestmentGroup(group, index, productIndex))}
            </>
        );
    };

    const renderTable = (data: IProductPerformanceDetailModel, productIndex) => {
        const InvestmentHoldings = data.NonModelSubTotal;
        const ModelProtofoilo = data.ModelSubTotal;

        return (
            <ScrollTable cssWrapper="investments-table mb-20">
                {renderHeader()}
                <tbody>
                    {props.view == ViewType.Product && renderNoDataRow(PerformanceDetailRowType.productRow, data)}
                    {renderSection(InvestmentHoldings, 0, data.NonModelAssetPerformanceDetail, productIndex)}
                    {renderSection(ModelProtofoilo, 1, data.ModelAssetPerformanceDetail, productIndex)}
                    {renderSection(data.OPIAssetPerformanceDetail[0], 2, data.OPIAssetPerformanceDetail, productIndex)}
                </tbody>
                <tfoot>{renderRow(PerformanceDetailRowType.total, data, 0)}</tfoot>
            </ScrollTable>
        );
    };

    return <>{props.data.map((product, index) => renderTable(product, index))}</>;
};
